import React, { ReactElement, ReactNode, forwardRef } from 'react';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';
import clsx from 'clsx';
import { styled } from '@mui/material';
import { A } from 'components/sx';

export interface LinkProps extends Omit<NextLinkProps, 'href'> {
  children: ReactNode;
  style?: React.CSSProperties;
  className?: string;
  href?: string;
  onClick?: () => void;
  target?: string;
  rel?: string;
  tabIndex?: number;
}

export const Link = styled(
  forwardRef(
    (
      {
        children,
        className,
        style,
        href,
        onClick,
        target,
        rel,
        tabIndex = 0,
        ...linkProps
      }: LinkProps,
      ref?: React.Ref<HTMLAnchorElement>,
    ): ReactElement => {
      style = {
        fontWeight: 500,
        ...style,
      };

      const handleClick = (e: React.MouseEvent | React.KeyboardEvent) => {
        if (!href && onClick) e.preventDefault();
        onClick?.();
      };

      const linkContent = (
        <A
          className={clsx('link', className, 'keyboardFocus')}
          onClick={handleClick}
          tabIndex={tabIndex}
          onKeyPress={e => e.key === 'Enter' && handleClick(e)}
          ref={ref}
          style={style}
          target={target}
          rel={rel}
        >
          {children}
        </A>
      );

      if (!href) return <>{linkContent}</>;

      return (
        <NextLink href={href} passHref {...linkProps}>
          {linkContent}
        </NextLink>
      );
    },
  ),
)``;
